// import * as d3 from 'd3'
const d3 = Object.assign(
  {},
  require('d3-selection'),
  require('d3-shape'),
  require('d3-scale'),
  require('d3-axis'),
  require('d3-transition'),
  require('d3-format')
)
import tippy from 'tippy.js'
import { hideAll } from 'tippy.js'

tippy.setDefaultProps({
  allowHTML: true,
  trigger: 'mouseenter focus',
  animation: 'fade',
  hideOnClick: true,
  interactive: false,
  maxWidth: 300,
  theme: 'cpp',
  duration: [null, 0],
  onMount(tip) {
    let close = document.querySelector('.tooltip-close')

    if (!close) return
    close.addEventListener('click', () => {
      tip.hide()
    })
  },
})

const tooltip = document.getElementById('tooltip')
let tooltipInstance
const chart = drawChart()

let el
let isMobile = window.innerWidth <= 500 ? true : false
// If needed, you can make modifications based on if you're viewing the chart on mobile or not.

// If  needed, declare any globally accessible variables you might need here to optimize selections
//let rects;
function resize() {
  let rows = isMobile ? 9 : 4
  let columns = isMobile ? 2 : 4
  const margin = { top: 30, left: 10 }

  const width = el.node().offsetWidth
  const maxRad = (width / (columns * 2)) * 0.9
  const height = margin.top + maxRad + rows * (maxRad * 2.2)

  chart.width(width)
  chart.height(height)

  el.call(chart)
}

function drawChart() {
  let width
  let height
  let isMobile = window.innerWidth <= 500 ? true : false
  let columns = isMobile ? 2 : 4

  let colorScale = d3
    .scaleOrdinal()
    .domain(['low', 'med', 'high', 'overall'])
    .range(['#bae4bc', '#7bccc4', '#43a2ca', '#FFFFFF'])

  let t

  /**
   *
   * Appends the SVG to the container. On updates, will make any necessary changes to width & height.
   *
   */

  function drawSVG({ container, data }) {
    container
      .selectAll('.chart')
      .data([data])
      .join((enter) =>
        enter
          .append('svg')
          .attr('class', 'chart')
          .call((enter) => {
            const g = enter.append('g')
            g.append('g').attr('class', 'g-plot')
          })
      )
      .attr('viewBox', `0 0 ${width} ${height}`)

    t = container.transition().duration(750)
  }

  /**
   *
   * Draw the main part of the chart: bars, lines, etc.
   *
   */

  function drawPlot({ container, data }) {
    const plot = container.select('.g-plot')

    const margin = { top: 30, left: 10 }
    const paddingText = 20
    const maxRad = (width / (columns * 2)) * 0.9

    let aScale = d3.scaleSqrt().domain([0, 1]).range([0, maxRad])

    let arc = d3
      .arc()
      .innerRadius(0)
      .outerRadius((d) => aScale(d.ratio))
      .startAngle(0)
      .endAngle((d) => (d.year === 1990 ? -Math.PI : Math.PI))

    plot
      .selectAll('text')
      .data(data, (d) => d.country)
      .join(
        (enter) =>
          enter
            .append('text')
            .attr('class', 'text-labels')
            .attr('transform', `translate(${width / 2}, ${height / 2})`)
            .call((enter) =>
              enter
                .transition()
                .duration(750)
                .delay((d, i) => i * 20)
                .attr(
                  'transform',
                  (d, i) =>
                    `translate(${
                      (i % columns) * (maxRad * 2.2) + margin.left + maxRad
                    },${
                      Math.floor(i / columns) * (maxRad * 2.6) + paddingText
                    })`
                )
            ),
        (update) =>
          update.call((update) =>
            update
              .transition()
              .duration(750)
              .delay((d, i) => i * 20)
              .attr(
                'transform',
                (d, i) =>
                  `translate(${
                    (i % columns) * (maxRad * 2.2) + margin.left + maxRad
                  },${Math.floor(i / columns) * (maxRad * 2.6) + paddingText})`
              )
          )
      )
      .text((d) => d.country)
      .attr('text-anchor', 'middle')
      .attr('font-family', 'sans-serif')

    let circle_groups = plot
      .selectAll('.circle-groups')
      .data(data, (d) => d.country)
      .join(
        (enter) =>
          enter
            .append('g')
            .attr('class', 'circle-groups')
            .attr('transform', `translate(${width / 2}, ${height / 2})`)
            .call((enter) =>
              enter
                .transition()
                .duration(750)
                .delay((d, i) => i * 20)
                .attr(
                  'transform',
                  (d, i) =>
                    `translate(${
                      (i % columns) * (maxRad * 2.2) + margin.left + maxRad
                    },${
                      Math.floor(i / columns) * (maxRad * 2.6) +
                      maxRad +
                      margin.top
                    })`
                )
            ),
        (update) =>
          update.call((update) =>
            update
              .transition()
              .duration(750)
              .delay((d, i) => i * 20)
              .attr(
                'transform',
                (d, i) =>
                  `translate(${
                    (i % columns) * (maxRad * 2.2) + margin.left + maxRad
                  },${
                    Math.floor(i / columns) * (maxRad * 2.6) +
                    maxRad +
                    margin.top
                  })`
              )
          )
      )
      .on('mouseover', interactions.mouseover)
      .on('mouseleave', interactions.mouseleave)

    circle_groups
      .selectAll('circle-paths')
      .data((d) => d.data)
      .join('path')
      .attr('d', arc)
      .attr('fill', (d) => colorScale(d.band))
      .attr('stroke', (d) => (d.band === 'overall' ? '#D0D0D0' : 'none'))
      .attr('stroke-width', 1)
  }

  const interactions = {
    mouseover(event, d) {
      if (this._tippy) {
        this._tippy.setContent(interactions.setTooltipContent(d))
        return
      }
      tooltipInstance = tippy(this, {
        content: interactions.setTooltipContent(d),
      })
    },
    mouseleave(event, d) {
      hideAll({ duration: 0, exclude: tooltipInstance })
    },
    setTooltipContent(d) {
      const container = document.createElement('div')

      function tooltipFormat(data, value) {
        let content = data
        const ratioFormat = d3.format('.1%')
        const absoluteFormat = d3.format('.2s')
        if (value.includes('ratio')) {
          content = `(${ratioFormat(data)})`
        } else if (value.includes('absolute')) {
          content = absoluteFormat(data).replace('G', 'B')
        }
        return content
      }

      const values = [
        'country',
        'ratio_190_1990',
        'ratio_320_1990',
        'ratio_550_1990',
        'absolute_190_1990',
        'absolute_320_1990',
        'absolute_550_1990',
        'ratio_190_2016',
        'ratio_320_2016',
        'ratio_550_2016',
        'absolute_190_2016',
        'absolute_320_2016',
        'absolute_550_2016',
      ]
      for (const value of values) {
        let content = tooltipFormat(d[value], value)
        tooltip.content.querySelector(
          `[data-value="${value}"]`
        ).innerHTML = content
      }
      const node = document.importNode(tooltip.content, true)
      container.appendChild(node)
      return container.innerHTML
    },
  }

  function chart(container) {
    const data = container.datum()

    drawSVG({ container, data })
    drawPlot({ container, data })
  }

  chart.width = function (...args) {
    if (!args.length) return width
    width = args[0]
    return chart
  }

  chart.height = function (...args) {
    if (!args.length) return height
    height = args[0]
    return chart
  }

  return chart
}

function init(args) {
  el = d3.select(args.container)
  el.datum(args.data)

  resize()
}

export default { init }
